import * as dataSourceExports from "@mecatran/datasource"
import * as model from "../schema/schema.mjs";

var { DataLoaderOptions, DataParserOptions,DataDeserializerOptions, DataSource,DataSourceOptions } = dataSourceExports;

/**
 * uses a DataSource but is not a datasource
 */
export class DestinationIndexSource{
    constructor(){

        this.init();

    }
    // ==========
    // private
    // ----------
    getSchema(bool){
        var scheduleModel;
        if (bool) {  // index.json 
            scheduleModel = model.getScheduleModel(true);
            return scheduleModel.DestinationIndex;
        } else {
            scheduleModel = model.getScheduleModel(false);
            return scheduleModel.ItineraryIndex;
        }
    }

    setDataSource(dataSource){ this.dataSource = dataSource }
    getDataSource(){ return this.dataSource }



    initDataSource(){
        var isIndex = true;
        var cache = true;
        var schema = this.getSchema(isIndex);
        var parserType = 'json';
        var url 
        //var url =`https://app.mecatran.com/utw/ws/gtfsfeed/static/pdlSco?apiKey=7c615b23662842016f190334533e041227327f15&type=schedules&element=index.json`; 
        var url ="https://app.mecatran.com/utw-test/ws/gtfsfeed/static/pdlSco?apiKey=79761945435426725f2f3261457e2d670f322f52&type=schedules&element=index.json"; //element=0720021G.json";
        var dataSourceOptions = Object.assign(new DataSourceOptions(), { 
                    name : 'schoolDataSource',
                    dataLoaderOptions : new DataLoaderOptions({url, cache}),
                    dataParserOptions : new DataParserOptions({parserType }),
                    dataDeserializerOptions : new DataDeserializerOptions({schema }),
                    dataTransformerOptions : undefined
                })
        var dataSource = new DataSource(dataSourceOptions);
        this.setDataSource(dataSource);
    }

    init(){
        this.initDataSource();
    }


    // ==========
    // public
    // ---------
    get(){ return this.getDataSource().get() }
}
